import asyncData from './async-data';
const plugins = [asyncData];
export default function install(Vue) {
    plugins.forEach(plugin => {
        Vue.use(plugin);
    });
}
